   import React, { useState, useEffect } from "react";
   import { useParams, Link } from "react-router-dom";
   import { format } from "date-fns";
   import { ToastContainer, toast } from "react-toastify";
   import "react-toastify/dist/ReactToastify.css";

   const BlogDetail = () => {
     const { id } = useParams();
     const [blog, setBlog] = useState(null);
     const [loading, setLoading] = useState(true);
     const [error, setError] = useState(null);

     // Fetch blog by ID with retry logic
     const fetchBlog = async (retryCount = 3) => {
       try {
         setLoading(true);
         setError(null);
         const response = await fetch(`/api/blogs/${id}`);
         if (!response.ok) throw new Error("Failed to fetch blog");
         const data = await response.json();
         setBlog({
           ...data,
           id: data.id.toString(),
           date: new Date(data.date),
           createdAt: new Date(data.createdAt),
         });
       } catch (err) {
         if (retryCount > 0) {
           setTimeout(() => fetchBlog(retryCount - 1), 2000);
         } else {
           setError(err.message || "Error loading blog");
           toast.error("Failed to load blog details");
         }
       } finally {
         setLoading(false);
       }
     };

     useEffect(() => {
       fetchBlog();
     }, [id]);

     if (loading) {
       return (
         <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-blue-200 to-gray-100">
           <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
         </div>
       );
     }

     if (error || !blog) {
       return (
         <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-blue-200 to-gray-100">
           <p className="text-red-500">{error || "Blog not found"}</p>
         </div>
       );
     }

     return (
       <div className="min-h-screen bg-gradient-to-b from-blue-200 to-gray-100 py-8 px-4">
         <div className="max-w-7xl mx-auto">
           <Link
             to="/blogs"
             className="inline-block mb-4 text-blue-600 hover:underline"
             aria-label="Back to blogs"
           >
             ← Back to Blogs
           </Link>
           <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
             {blog.title}
           </h1>
           <div className="flex justify-between text-gray-500 text-sm mb-6">
             <span className="inline-block bg-blue-600 text-white text-xs font-semibold px-2 py-1 rounded">
               {blog.category}
             </span>
             <span>{format(blog.date, "MMMM dd, yyyy")} • {blog.readTime}</span>
           </div>
           <div className="bg-white rounded-lg shadow-lg p-6">
             <p className="text-gray-600 mb-4">{blog.excerpt}</p>
             <p className="text-gray-700">
               {blog.content || "Full blog content will be displayed here once available. Contact us for more details!"}
             </p>
           </div>
         </div>
         <ToastContainer
           position="top-right"
           autoClose={3000}
           hideProgressBar={false}
           newestOnTop={false}
           closeOnClick
           rtl={false}
           pauseOnFocusLoss
           draggable
           pauseOnHover
           theme="light"
         />
       </div>
     );
   };

   export default BlogDetail;
   
